import {ActionButton as $b41412308e87d8d9$export$cfc7921d29ef7b80} from "../button/ActionButton.mjs";
import "../button_vars.css";
import $2VrXO$button_vars_cssmjs from "../button_vars_css.mjs";
import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {ClearSlots as $62024859ff9f1f8a$export$ceb145244332b7a2, SlotProvider as $62024859ff9f1f8a$export$8107b24b91795686, useSlotProps as $62024859ff9f1f8a$export$1e5c9e6e4e15efe3} from "../utils/Slots.mjs";
import $2VrXO$intlStringsmjs from "./intlStrings.mjs";
import {Menu as $8cccdb0b63bfcdeb$export$d9b273488cd8ce6f} from "../menu/Menu.mjs";
import {MenuTrigger as $9928637078ff3033$export$27d2ad3c5815583e} from "../menu/MenuTrigger.mjs";
import {Provider as $71dfb0e0358a12de$export$2881499e37b75b9a, useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import "../actiongroup_vars.css";
import $2VrXO$actiongroup_vars_cssmjs from "../actiongroup_vars_css.mjs";
import {Text as $f8cc90fea9436c19$export$5f1af8db9871e1d6} from "../text/Text.mjs";
import {Tooltip as $91ff1bc0856186a6$export$28c660c63b792dea} from "../tooltip/Tooltip.mjs";
import {TooltipTrigger as $1db3f28f9989b2cd$export$8c610744efcf8a1d} from "../tooltip/TooltipTrigger.mjs";
import {useDOMRef as $3c2c983d5210446c$export$c2c55ef9111cafd8} from "../utils/useDOMRef.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {useActionGroup as $2VrXO$useActionGroup} from "react-aria/private/actiongroup/useActionGroup";
import $2VrXO$spectrumiconsuiChevronDownMedium from "@spectrum-icons/ui/ChevronDownMedium";
import {filterDOMProps as $2VrXO$filterDOMProps} from "react-aria/filterDOMProps";
import {FocusScope as $2VrXO$FocusScope} from "react-aria/FocusScope";
import {Item as $2VrXO$Item} from "react-stately/Item";
import {useListState as $2VrXO$useListState} from "react-stately/useListState";
import {mergeProps as $2VrXO$mergeProps} from "react-aria/mergeProps";
import $2VrXO$spectrumiconsworkflowMore from "@spectrum-icons/workflow/More";
import {PressResponder as $2VrXO$PressResponder} from "react-aria/private/interactions/PressResponder";
import $2VrXO$react, {forwardRef as $2VrXO$forwardRef, useRef as $2VrXO$useRef, useMemo as $2VrXO$useMemo, useCallback as $2VrXO$useCallback, useState as $2VrXO$useState} from "react";
import {useActionGroupItem as $2VrXO$useActionGroupItem} from "react-aria/private/actiongroup/useActionGroupItem";
import {useHover as $2VrXO$useHover} from "react-aria/useHover";
import {useId as $2VrXO$useId} from "react-aria/useId";
import {useLayoutEffect as $2VrXO$useLayoutEffect} from "react-aria/private/utils/useLayoutEffect";
import {useLocalizedStringFormatter as $2VrXO$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";
import {useResizeObserver as $2VrXO$useResizeObserver} from "react-aria/private/utils/useResizeObserver";
import {useValueEffect as $2VrXO$useValueEffect} from "react-aria/private/utils/useValueEffect";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 






























const $e4f8d481fcca6617$export$c21a5597f732a168 = /*#__PURE__*/ (0, $2VrXO$forwardRef)(function ActionGroup(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    props = (0, $62024859ff9f1f8a$export$1e5c9e6e4e15efe3)(props, 'actionGroup');
    let { isEmphasized: isEmphasized, density: density, isJustified: isJustified, isDisabled: isDisabled, orientation: orientation = 'horizontal', isQuiet: isQuiet, staticColor: staticColor, overflowMode: overflowMode = 'wrap', onAction: onAction, buttonLabelBehavior: buttonLabelBehavior, summaryIcon: summaryIcon, ...otherProps } = props;
    let domRef = (0, $3c2c983d5210446c$export$c2c55ef9111cafd8)(ref);
    let wrapperRef = (0, $2VrXO$useRef)(null);
    let state = (0, $2VrXO$useListState)({
        ...props,
        suppressTextValueWarning: true
    });
    let { actionGroupProps: actionGroupProps } = (0, $2VrXO$useActionGroup)(props, state, domRef);
    let isVertical = orientation === 'vertical';
    let providerProps = {
        isEmphasized: isEmphasized,
        isDisabled: isDisabled,
        isQuiet: isQuiet
    };
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(props);
    // Only hide button text if every item contains more than just plain text (we assume an icon).
    let isIconCollapsible = (0, $2VrXO$useMemo)(()=>[
            ...state.collection
        ].every((item)=>typeof item.rendered !== 'string'), [
        state.collection
    ]);
    let [{ visibleItems: visibleItems, hideButtonText: hideButtonText, isMeasuring: isMeasuring }, setVisibleItems] = (0, $2VrXO$useValueEffect)({
        visibleItems: state.collection.size,
        hideButtonText: buttonLabelBehavior === 'hide' && isIconCollapsible,
        isMeasuring: false
    });
    let selectionMode = state.selectionManager.selectionMode;
    let updateOverflow = (0, $2VrXO$useCallback)(()=>{
        if (overflowMode === 'wrap') return;
        if (orientation === 'vertical' && selectionMode !== 'none') // Collapsing vertical action groups with selection is currently unsupported by Spectrum.
        return;
        let computeVisibleItems = (visibleItems)=>{
            if (domRef.current && wrapperRef.current) {
                let listItems = Array.from(domRef.current.children);
                let containerSize = orientation === 'horizontal' ? wrapperRef.current.getBoundingClientRect().width : wrapperRef.current.getBoundingClientRect().height;
                let isShowingMenu = visibleItems < state.collection.size;
                let calculatedSize = 0;
                let newVisibleItems = 0;
                if (isShowingMenu) {
                    let item = listItems.pop();
                    if (item) calculatedSize += orientation === 'horizontal' ? $e4f8d481fcca6617$var$outerWidth(item, false, true) : $e4f8d481fcca6617$var$outerHeight(item, false, true);
                }
                for (let [i, item] of listItems.entries()){
                    calculatedSize += orientation === 'horizontal' ? $e4f8d481fcca6617$var$outerWidth(item, i === 0, i === listItems.length - 1) : $e4f8d481fcca6617$var$outerHeight(item, i === 0, i === listItems.length - 1);
                    if (Math.round(calculatedSize) <= Math.round(containerSize)) newVisibleItems++;
                    else break;
                }
                // If selection is enabled, and not all of the items fit, collapse all of them into a dropdown
                // immediately rather than having some visible and some not.
                if (selectionMode !== 'none' && newVisibleItems < state.collection.size) return 0;
                return newVisibleItems;
            }
            return visibleItems;
        };
        setVisibleItems(function*() {
            let hideButtonText = buttonLabelBehavior === 'hide' && isIconCollapsible;
            // Update to show all items.
            yield {
                visibleItems: state.collection.size,
                hideButtonText: hideButtonText,
                isMeasuring: true
            };
            // Measure, and update to show the items that fit.
            let newVisibleItems = computeVisibleItems(state.collection.size);
            let isMeasuring = newVisibleItems < state.collection.size && newVisibleItems > 0;
            // If not all of the buttons fit, and buttonLabelBehavior is 'collapse', then first try hiding
            // the button text and only showing icons. Only if that still doesn't fit collapse into a menu.
            if (newVisibleItems < state.collection.size && buttonLabelBehavior === 'collapse' && isIconCollapsible) {
                yield {
                    visibleItems: state.collection.size,
                    hideButtonText: true,
                    isMeasuring: true
                };
                newVisibleItems = computeVisibleItems(state.collection.size);
                isMeasuring = newVisibleItems < state.collection.size && newVisibleItems > 0;
                hideButtonText = true;
            }
            yield {
                visibleItems: newVisibleItems,
                hideButtonText: hideButtonText,
                isMeasuring: isMeasuring
            };
            // If the number of items is less than the number of children,
            // then update again to ensure that the menu fits.
            if (isMeasuring) yield {
                visibleItems: computeVisibleItems(newVisibleItems),
                hideButtonText: hideButtonText,
                isMeasuring: false
            };
        });
    }, [
        domRef,
        state.collection,
        setVisibleItems,
        overflowMode,
        selectionMode,
        buttonLabelBehavior,
        isIconCollapsible,
        orientation
    ]);
    // Watch the parent element for size changes. Watching only the action group itself may not work
    // in all scenarios because it may not shrink when available space is reduced.
    let parentRef = (0, $2VrXO$useMemo)(()=>({
            get current () {
                return wrapperRef.current?.parentElement;
            }
        }), [
        wrapperRef
    ]);
    (0, $2VrXO$useResizeObserver)({
        ref: overflowMode !== 'wrap' ? parentRef : undefined,
        onResize: updateOverflow
    });
    (0, $2VrXO$useLayoutEffect)(updateOverflow, [
        updateOverflow,
        state.collection
    ]);
    let children = [
        ...state.collection
    ];
    let menuItem = null;
    let menuProps = {};
    // If there are no visible items, don't apply any props to the action group container
    // and pass all aria labeling props through to the menu button.
    if (overflowMode === 'collapse' && visibleItems === 0) {
        menuProps = (0, $2VrXO$filterDOMProps)(props, {
            labelable: true
        });
        actionGroupProps = {};
    }
    if (overflowMode === 'collapse' && visibleItems < state.collection.size) {
        let menuChildren = children.slice(visibleItems);
        children = children.slice(0, visibleItems);
        menuItem = /*#__PURE__*/ (0, $2VrXO$react).createElement($e4f8d481fcca6617$var$ActionGroupMenu, {
            ...menuProps,
            items: menuChildren,
            onAction: onAction,
            isDisabled: isDisabled,
            isEmphasized: isEmphasized,
            staticColor: staticColor,
            state: state,
            summaryIcon: summaryIcon,
            hideButtonText: hideButtonText,
            isOnlyItem: visibleItems === 0,
            orientation: orientation
        });
    }
    let style = {
        ...styleProps.style,
        // While measuring, take up as much space as possible.
        flexBasis: isMeasuring ? '100%' : undefined
    };
    return /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $2VrXO$FocusScope), null, /*#__PURE__*/ (0, $2VrXO$react).createElement("div", {
        ...styleProps,
        style: style,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($2VrXO$actiongroup_vars_cssmjs))), 'flex-container', styleProps.className),
        ref: wrapperRef
    }, /*#__PURE__*/ (0, $2VrXO$react).createElement("div", {
        ...actionGroupProps,
        ref: domRef,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($2VrXO$actiongroup_vars_cssmjs))), 'flex-gap', 'spectrum-ActionGroup', {
            'spectrum-ActionGroup--quiet': isQuiet,
            'spectrum-ActionGroup--vertical': isVertical,
            'spectrum-ActionGroup--compact': density === 'compact',
            'spectrum-ActionGroup--justified': isJustified && !isMeasuring,
            'spectrum-ActionGroup--overflowCollapse': overflowMode === 'collapse'
        }, otherProps.UNSAFE_className)
    }, /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $71dfb0e0358a12de$export$2881499e37b75b9a), providerProps, children.map((item)=>/*#__PURE__*/ (0, $2VrXO$react).createElement($e4f8d481fcca6617$var$ActionGroupItem, {
            key: item.key,
            onAction: onAction,
            isDisabled: isDisabled,
            isEmphasized: isEmphasized,
            staticColor: staticColor,
            item: item,
            state: state,
            hideButtonText: hideButtonText,
            orientation: orientation
        })), menuItem))));
});
function $e4f8d481fcca6617$var$ActionGroupItem({ item: item, state: state, isDisabled: isDisabled, isEmphasized: isEmphasized, staticColor: staticColor, onAction: onAction, hideButtonText: hideButtonText, orientation: orientation }) {
    let ref = (0, $2VrXO$useRef)(null);
    let { buttonProps: buttonProps } = (0, $2VrXO$useActionGroupItem)({
        key: item.key
    }, state);
    isDisabled = isDisabled || state.disabledKeys.has(item.key);
    let isSelected = state.selectionManager.isSelected(item.key);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $2VrXO$useHover)({
        isDisabled: isDisabled
    });
    let domProps = (0, $2VrXO$filterDOMProps)(item.props);
    if (onAction && !isDisabled) buttonProps = (0, $2VrXO$mergeProps)(buttonProps, {
        onPress: ()=>onAction(item.key)
    });
    // If button text is hidden, we need to show it as a tooltip instead, so
    // go find the text element in the DOM after rendering.
    let textId = (0, $2VrXO$useId)();
    let [textContent, setTextContent] = (0, $2VrXO$useState)('');
    (0, $2VrXO$useLayoutEffect)(()=>{
        if (hideButtonText) setTextContent(document.getElementById(textId)?.textContent);
    }, [
        hideButtonText,
        item.rendered,
        textId
    ]);
    let button = /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $2VrXO$PressResponder), (0, $2VrXO$mergeProps)(buttonProps, hoverProps, domProps), /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $62024859ff9f1f8a$export$ceb145244332b7a2), null, /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $62024859ff9f1f8a$export$8107b24b91795686), {
        slots: {
            text: {
                id: hideButtonText ? textId : null,
                isHidden: hideButtonText
            }
        }
    }, /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $b41412308e87d8d9$export$cfc7921d29ef7b80), {
        ref: ref,
        // @ts-ignore (private)
        hideButtonText: hideButtonText,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($2VrXO$actiongroup_vars_cssmjs))), 'spectrum-ActionGroup-item', {
            'is-selected': isSelected,
            'is-hovered': isHovered,
            'spectrum-ActionGroup-item--iconOnly': hideButtonText,
            'spectrum-ActionGroup-item--isDisabled': isDisabled
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($2VrXO$button_vars_cssmjs))), {
            'spectrum-ActionButton--emphasized': isEmphasized,
            'is-selected': isSelected
        })),
        isDisabled: isDisabled,
        staticColor: staticColor,
        "aria-label": item['aria-label'],
        "aria-labelledby": item['aria-label'] == null && hideButtonText ? textId : undefined
    }, item.rendered))));
    if (hideButtonText && textContent) button = /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $1db3f28f9989b2cd$export$8c610744efcf8a1d), {
        placement: orientation === 'vertical' ? 'end' : 'top'
    }, button, /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $91ff1bc0856186a6$export$28c660c63b792dea), null, textContent));
    if (item.wrapper) button = item.wrapper(button);
    return button;
}
function $e4f8d481fcca6617$var$ActionGroupMenu({ state: state, isDisabled: isDisabled, isEmphasized: isEmphasized, staticColor: staticColor, items: items, onAction: onAction, summaryIcon: summaryIcon, hideButtonText: hideButtonText, isOnlyItem: isOnlyItem, orientation: orientation, ...otherProps }) {
    // Use the key of the first item within the menu as the key of the button.
    // The key must actually exist in the collection for focus to work correctly.
    let key = items[0].key;
    let { buttonProps: buttonProps } = (0, $2VrXO$useActionGroupItem)({
        key: key
    }, state);
    let stringFormatter = (0, $2VrXO$useLocalizedStringFormatter)((0, ($parcel$interopDefault($2VrXO$intlStringsmjs))), '@react-spectrum/actiongroup');
    // The menu button shouldn't act like an actual action group item.
    delete buttonProps.onPress;
    delete buttonProps.role;
    delete buttonProps['aria-checked'];
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $2VrXO$useHover)({
        isDisabled: isDisabled
    });
    // If no aria-label or aria-labelledby is given, provide a default one.
    let ariaLabel = otherProps['aria-label'] || (otherProps['aria-labelledby'] ? undefined : stringFormatter.format('more'));
    let ariaLabelledby = otherProps['aria-labelledby'];
    let textId = (0, $2VrXO$useId)();
    let id = (0, $2VrXO$useId)();
    // Summary icon only applies when selection is enabled.
    if (state.selectionManager.selectionMode === 'none') summaryIcon = null;
    let iconOnly = false;
    // If there is a selection, show the selected state on the menu button.
    let isSelected = state.selectionManager.selectionMode !== 'none' && !state.selectionManager.isEmpty;
    // If single selection and empty selection is not allowed, swap the contents of the button to the selected item (like a Picker).
    if (!summaryIcon && state.selectionManager.selectionMode === 'single' && state.selectionManager.disallowEmptySelection && state.selectionManager.firstSelectedKey != null) {
        let selectedItem = state.collection.getItem(state.selectionManager.firstSelectedKey);
        if (selectedItem) {
            summaryIcon = selectedItem.rendered;
            if (typeof summaryIcon === 'string') summaryIcon = /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $f8cc90fea9436c19$export$5f1af8db9871e1d6), null, summaryIcon);
            iconOnly = !!hideButtonText;
            ariaLabelledby = `${ariaLabelledby ?? id} ${textId}`;
        }
    }
    if (summaryIcon) // If there's a custom summary icon, also add a chevron.
    summaryIcon = /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $2VrXO$react).Fragment, null, /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $2VrXO$spectrumiconsuiChevronDownMedium), {
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($2VrXO$actiongroup_vars_cssmjs))), 'spectrum-ActionGroup-menu-chevron')
    }), /*#__PURE__*/ (0, $2VrXO$react).createElement("span", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($2VrXO$actiongroup_vars_cssmjs))), 'spectrum-ActionGroup-menu-contents', {
            'spectrum-ActionGroup-item--iconOnly': iconOnly
        })
    }, summaryIcon));
    return /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $9928637078ff3033$export$27d2ad3c5815583e), {
        align: isOnlyItem ? 'start' : 'end',
        direction: orientation === 'vertical' ? 'end' : 'bottom'
    }, /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $62024859ff9f1f8a$export$8107b24b91795686), {
        slots: {
            text: {
                id: hideButtonText ? textId : null,
                isHidden: hideButtonText,
                UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($2VrXO$actiongroup_vars_cssmjs))), 'spectrum-ActionGroup-menu-text')
            }
        }
    }, /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $2VrXO$PressResponder), (0, $2VrXO$mergeProps)(buttonProps, hoverProps), /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $b41412308e87d8d9$export$cfc7921d29ef7b80), {
        ...otherProps,
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($2VrXO$actiongroup_vars_cssmjs))), 'spectrum-ActionGroup-item', 'spectrum-ActionGroup-menu', {
            'is-hovered': isHovered,
            'is-selected': isSelected
        }, (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($2VrXO$button_vars_cssmjs))), {
            'is-selected': isSelected,
            'spectrum-ActionButton--emphasized': isEmphasized
        })),
        isDisabled: isDisabled,
        staticColor: staticColor
    }, summaryIcon || /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $2VrXO$spectrumiconsworkflowMore), null)))), /*#__PURE__*/ (0, $2VrXO$react).createElement((0, $8cccdb0b63bfcdeb$export$d9b273488cd8ce6f), {
        items: items,
        disabledKeys: state.disabledKeys,
        selectionMode: state.selectionManager.selectionMode,
        selectedKeys: state.selectionManager.selectedKeys,
        disallowEmptySelection: state.selectionManager.disallowEmptySelection,
        onSelectionChange: (keys)=>state.selectionManager.setSelectedKeys(keys),
        onAction: onAction
    }, (node)=>/*#__PURE__*/ (0, $2VrXO$react).createElement((0, $2VrXO$Item), {
            textValue: node.textValue,
            ...(0, $2VrXO$filterDOMProps)(node.props)
        }, node.rendered)));
}
function $e4f8d481fcca6617$var$outerWidth(element, ignoreLeftMargin, ignoreRightMargin) {
    let style = window.getComputedStyle(element);
    return element.getBoundingClientRect().width + (ignoreLeftMargin ? 0 : $e4f8d481fcca6617$var$toNumber(style.marginLeft)) + (ignoreRightMargin ? 0 : $e4f8d481fcca6617$var$toNumber(style.marginRight));
}
function $e4f8d481fcca6617$var$outerHeight(element, ignoreTopMargin, ignoreBottomMargin) {
    let style = window.getComputedStyle(element);
    return element.getBoundingClientRect().height + (ignoreTopMargin ? 0 : $e4f8d481fcca6617$var$toNumber(style.marginTop)) + (ignoreBottomMargin ? 0 : $e4f8d481fcca6617$var$toNumber(style.marginBottom));
}
function $e4f8d481fcca6617$var$toNumber(value) {
    let parsed = parseInt(value, 10);
    return isNaN(parsed) ? 0 : parsed;
}


export {$e4f8d481fcca6617$export$c21a5597f732a168 as ActionGroup};
//# sourceMappingURL=ActionGroup.mjs.map
